import React from "react";
import axios from "axios";
import { X } from "lucide-react";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
const STORAGE_KEY = "novalynx_ann_dismissed_v";

export default function AnnouncementBar() {
  const [ann, setAnn] = React.useState(null);
  const [dismissed, setDismissed] = React.useState(false);

  React.useEffect(() => {
    let mounted = true;
    axios.get(`${API}/settings/announcement`).then((r) => {
      if (!mounted) return;
      const d = r.data;
      if (!d?.active) return;
      const dismissedVersion = localStorage.getItem(STORAGE_KEY);
      if (dismissedVersion && parseInt(dismissedVersion, 10) === d.version) {
        setDismissed(true);
      }
      setAnn(d);
    }).catch(() => {});
    return () => { mounted = false; };
  }, []);

  if (!ann || !ann.active || dismissed) return null;

  const dismiss = () => {
    localStorage.setItem(STORAGE_KEY, String(ann.version));
    setDismissed(true);
  };

  return (
    <div className="bg-primary text-primary-foreground" data-testid="announcement-bar">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-2 flex items-center gap-3 text-xs sm:text-sm font-medium">
        <span className="flex-1 text-center sm:text-left" data-testid="announcement-text">
          {ann.text}
          {ann.link_url && ann.link_label && (
            <a href={ann.link_url} className="ml-2 underline underline-offset-2 font-bold" data-testid="announcement-link">
              {ann.link_label} →
            </a>
          )}
        </span>
        <button
          onClick={dismiss}
          className="shrink-0 opacity-70 hover:opacity-100 transition"
          aria-label="Dismiss announcement"
          data-testid="announcement-dismiss"
        >
          <X className="h-4 w-4" />
        </button>
      </div>
    </div>
  );
}
